import { render, staticRenderFns } from "./PropertyIconList.vue?vue&type=template&id=46d76afe&"
import script from "./PropertyIconList.vue?vue&type=script&lang=js&"
export * from "./PropertyIconList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports